import {ElementRef, Pipe, PipeTransform} from '@angular/core';
import * as punycode from 'punycode';

@Pipe({
    name: 'domainNameConverter',
    standalone: false
})
export class DomainNameConverterPipe implements PipeTransform {

    constructor(private el: ElementRef) {
    }

    transform(value: string, domainHeaderView?: boolean): unknown {
        if (value == null) {
            return '';
        }

        if (value === '.') {
            return '.(Root)';
        }

        let unicode = punycode.toUnicode(value);

        // except for header, links & table elements, domains should be displayed with a dot ( "." ):
        unicode = this.addLeadingDot(domainHeaderView, unicode);
        value = this.addLeadingDot(domainHeaderView, value);

        if (unicode === value) {
            return unicode.toLowerCase();
        }

        if (domainHeaderView) {
            return '<span>' + unicode + '</span><span>' + value + '</span>';
        } else {
            return unicode + ' (' + value + ')';
        }
    }

    private addLeadingDot(domainHeaderView: boolean, tld: string): string {
        if (!domainHeaderView && !['A', 'TD'].includes(this.el.nativeElement.parentNode.tagName) && !tld.startsWith('.') && !tld.endsWith('.')) {
            tld = '.' + tld;
        }
        return tld;
    }
}
